import { h } from 'preact'
import { Banniere2images } from '../banniere-2-images/banniere-2-images.jsx'

export const JeuxVideo = ({ title, URL, images, alt, analytics, cacheKey }) => {
   let props = {
      tag: '',
      date: '',
      title: '',
      description: '',
      legals: '',
      legalNotice: {
         title: '',
         content: '',
         showButtonLabel: '',
         background: '',
         index: 0,
      },
      images: images,
      URL: URL,
      textColor: 'white',
      analytics: analytics,
      cacheKey: cacheKey,
      alt: alt,
      index: 0,
      format: '1440x310-960x1040',
   }
   return (
      <div data-testid="bande-jeux-video" data-cache-key={cacheKey}>
         <div class="container-fluid pt-2">
            <div class="row">
               <div class="col-12">
                  <h2>{title}</h2>
               </div>
            </div>
         </div>
         <div class="row no-gutters">
            <div class="col-12">
               <Banniere2images {...props} />
            </div>
         </div>
      </div>
   )
}
